import { useEffect, useState } from "react";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { workOrder } from "../../api";
import { toast } from "react-toastify";
import { formatDateOnly, getStatusColor, printLocation } from "../../utils/helper";
import { useNavigate } from "react-router-dom";
import DataTablePagination from "../../components/DataTablePagination";

const statuses = ["Open", "In Progress", "On Hold", "Completed"];

const WorkOrder = ({ workOrder, moveWorkOrder }) => {

const navigate = useNavigate()
  const [{ isDragging }, drag] = useDrag(() => ({
    type: "WORK_ORDER",
    item: { id: workOrder.id },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
      }),
  }));

  return (
      <div
          onClick={()=>navigate(`/work-order/detail/${workOrder.id}`)}
      ref={drag}
          className={`p-3 mb-3 ${isDragging ? "opacity-50" : ""}`}
          style={{ border: '1px solid #5a5a5a', cursor:'grab'}}
      >
    
      <div className="">
              <p className="card-title fw-bold">{workOrder.title}</p>
              <p className="card-title"><i className="bi bi-tag"></i> {workOrder.category?.name}</p>
              <p className="card-title text-muted"><i className="bi bi-inbox"></i> {workOrder.asset?.asset_name} - {printLocation(workOrder.asset?.location?.location_name)}</p>
              <p className="text-muted"><i className="bi bi-clock"></i> {formatDateOnly(workOrder.created_at)}</p>
              <p>
              <span
          className={`badge border ${
            workOrder.priority === "high"
              ? "border-danger text-danger"
              : workOrder.priority === "medium"
              ? "border-warning text-warning"
              : "border-success text-success"
            }`}
          style={{textTransform:'capitalize'}}
        >
          {workOrder.priority}
        </span>  
              </p>
           
      </div>
    </div>
  );
};

const Column = ({ status, workOrders, moveWorkOrder }) => {
  const [, drop] = useDrop(() => ({
    accept: "WORK_ORDER",
    drop: (item) => moveWorkOrder(item.id, status),
  }));

  return (
    <div ref={drop} className="col  p-3 rounded shadow-sm" style={{ background: "#1d2835ab" }}>
      <div className="d-flex mb-3 gap-2 align-items-baseline">
      <h2 className="h5 fw-bold">{status} ({workOrders.length}) </h2>
      <div
        className={`bg-${getStatusColor(status)
          
          } text-${getStatusColor(status)}`}
        style={{width:20,height:15}}
              >
              </div>
      </div>
     
      <div>
        {workOrders.map((order) => (
          <WorkOrder key={order.id} workOrder={order} moveWorkOrder={moveWorkOrder} />
        ))}
      </div>
    </div>
  );
};

const WorkOrderKanbanBoard = ({datas,isRequest=false,onChangeRowsPerPage,paginationTotalRows,onChangePage,query}) => {
  const [workOrders, setWorkOrders] = useState([]);
  

  useEffect(() => {
    
    setWorkOrders(datas)

  },[datas])
    

    const handleChangeStatus = async (id,status) => {
        try {
          let result
          if (isRequest) {
             result = await workOrder.updateRequestStatus(id, { status })
          } else {
             result = await workOrder.updateStatus(id, { status})
          }
       
          if (result.ok) {
            toast.success('Status updated')
          } else {
            toast.error('Status failed to update')
          }
        } catch (e) {
          toast.error(e.message)
        }
        
        
      }
    

    const moveWorkOrder = async (id, newStatus) => {
  
    setWorkOrders((prevOrders) =>
      prevOrders.map((order) => (order.id === id ? { ...order, status: newStatus } : order))
    );
    await handleChangeStatus(id,newStatus)
  };

  return (
    <>
 
    <DndProvider backend={HTML5Backend}>
      <div className="container d-flex gap-3 overflow-auto" style={{marginTop:30}}>
        {statuses.map((status) => (
          <Column
            key={status}
            status={status}
            workOrders={workOrders.filter((order) => order.status === status)}
            moveWorkOrder={moveWorkOrder}
          />
        ))}
      </div>
      </DndProvider>

      <div>
        <DataTablePagination  
          rowsPerPage={query.take}
          currentPage={query.page}
          totalRows={paginationTotalRows}
          onChangePage={onChangePage}
          onChangeRowsPerPage={onChangeRowsPerPage}
        />
      </div>
      
      </>
  );
};

export default WorkOrderKanbanBoard;
